export default function PhotoPackInfo({ packs = [] }) {
  if (!packs.length) {
    return null;
  }

  return (
    <div className="photo-pack-info">
      {packs.map((pack) => (
        <div
          key={pack.id}
          className="photo-pack-card"
        >
          <strong>{pack.quantity} fotos</strong>

          <span>
            {pack.price.toFixed(2)} €
          </span>
        </div>
      ))}
    </div>
  );
}